export default __webpack_public_path__ + "static/media/hero-1.c1b3dd8b.svg";